import { defineStore } from "pinia";
import UserResource from "~/models/User";
import SystemResource from "~/models/System";

import { useAuth } from '~/composables/useAuth';

// eslint-disable-next-line no-unused-vars
const unauthenticatedLinksNuxtUi = [
  [{
    key: 'home',
    label: 'Home',
    icon: 'i-heroicons-home',
    to: '/'
  }],
  [{
    key: 'profile',
    label: 'Profile',
    icon: 'i-heroicons-user',
    to: '/profile'
  }, {
    key: 'form',
    label: 'View Form',
    icon: 'i-heroicons-clipboard-document-list-solid',
    to: '/blank' //'/form'
  }, {
    key: 'login',
    label: 'Leyden Website',
    icon: 'i-lucide-globe',
    href: 'http://www.leyden212.org/',
    target: '_blank'
  }]
];

const unauthenticatedLinks = [
  {
    title: "Login",
    active_flag: "login",
    icon: "school",
    url: { name: "auth-login" }, // "/auth/login"
  },
  {
    title: "Leyden Website",
    active_flag: "LeydenHighSchools",
    icon: "favorite",
    url: "https://www.leyden212.org",
  },
];

// eslint-disable-next-line no-unused-vars
const authPreMenuLinks = [
  {
    id: 'home',
    title: "Home",
    active_flag: "",
    icon: "home",
    url: { name: "index" },
  }
];
// eslint-disable-next-line no-unused-vars
const authPostMenuLinks = [
  {
    id: 'sign-out',
    title: 'Sign Out',
    icon: 'door-closed',
    url: { name: 'auth-logout' }
  }
];

const unauthenticatedUser = { //new UserResource();
  id: null,
  first_name: "Unauthenticated",
  last_name: "User",
  display_name: "Unauthenticated User",
  description: null,
  email: "",
  username: "",
  password: "",
  active: false,
  roles: [],
  permissions: [],
};

export const useAuthStore = defineStore("auth", {
  state: () => ({
    isAuthenticated: null,
    menu: [],
    user: unauthenticatedUser,
    ttoken: {
      token_type: 'Bearer',
      access_token: null,
      refresh_token: null,
      expires_in: null,
    },
  }),
  getters: {
    token: () => {
      const { authState } = useAuth();
      return authState;
    },
    menu_display: () => {
      const { user, isAuthenticated } = useAuth();
      if (isAuthenticated.value) {
        return user?.value.mylhs?.menu_items || [];
      }
      return unauthenticatedLinks;
    },
    mmmenu_display: (state) => {
      if (!state.menu || state.menu.length == 0) {
        // No menu available, show logged out menu.
        return unauthenticatedLinks;
      }

      // Send merged menu 
      return [
        //...authPreMenuLinks,
        ...state.menu,
        //...authPostMenuLinks
      ];
    }
  },
  actions: {
    async init() {
      const { user, initAuth, isAuthenticated } = useAuth();
      await initAuth();
      if (isAuthenticated.value) {
        this.setMetadata(user.value.mylhs);
        this.setUser(user.value.data);
      }
      return;
    },
    getUseAuth() {
      return useAuth();
    },
    async checkLogin(credentials) {
      try {
        const { loginWithPassword } = useAuth();
        credentials.value.processing = true;
        const me = await loginWithPassword(credentials.value.username, credentials.value.password);
        this.setMetadata(me.mylhs);
        this.setUser(me.data);
        credentials.value.processing = false;
      } catch (error) {
        // Failed login, handle error.
        credentials.value.processing = false;
        if (error.response && error.response.status == 400) {
          error.response._data.errors = {
            username: [error.response._data.error_description],
          };
          //credentials.value.onFail(error);
        }
        throw error;
        //apiResponseHandler.error(error, "Unable to login");
      }

    },
    loginProvider(provider) {
      const { loginWithProvider } = useAuth();
      loginWithProvider(provider);
    },
    setUser(userData) {
      let permissions = [];

      if (userData.roles != null && userData.roles.length) {
        // Gather user's roles
        userData.roles.forEach((role) => {
          // Gather role's permissions
          if (role.permissions != null && role.permissions.length) {
            role.permissions.forEach((perm) => {
              permissions.push(perm);
            });
          }
        });
      }
      this.user = new UserResource(userData);
      this.user.permissions = permissions;
      this.isAuthenticated = true;

      // const system = useSystemStore();
      // system.loadConfig();
      const { $bugsnag } = useNuxtApp();
      $bugsnag.setUser(this.user.id, this.user.email, this.user.display_name);
    },
    async logoutUser() {
      try {
        const { logout } = useAuth();
        await logout();
      } catch (error) {
        apiResponseHandler.error(error, "Issue trying to logout");
      }
      this.resetUser();
      navigateTo('/auth/login', { replace: true });
    },
    resetUser() {
      this.isAuthenticated = false;
      this.user = unauthenticatedUser;
      this.resetMenu();
      // LocalStorage.clear(); // Old: import {LocalStorage} from "Quasar"

      const { $bugsnag } = useNuxtApp();
      $bugsnag.setUser();
    },

    /**
     * Menu & Config
     */
    setMetadata(config) {
      this.setMenu(config.menu_items);
    },
    setMenu(menuItems) {
      console.log('systemstore:setMenu', menuItems);
      this.menu = menuItems;
    },
    resetMenu() {
      this.menu = [];
    },
    async loadMetadata() {
      try {
        const response = await SystemResource.custom("metadata").first();
        this.setMenu(response.menu_items);
      } catch (error) {
        console.log(SystemResource, error);
        apiResponseHandler.error(error, "Unable to retrieve system configuration. ");
      }
    },
  },
});
